module.exports = __webpack_public_path__ + "static/media/arrowTax.2795e822.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrowTax.png
// module id = 1008
// module chunks = 0